import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import type {
  StoreProductVariantOptions,
  StoreVariant
} from '@/domains/products/store/use-product-variant-store/ProductVariantStore.types.ts'
import type { VariantModel } from '@/domains/variants/types/models/VariantModel.types.ts'

import { useProductStore } from '@/domains/products/store/use-product-store/useProductStore.ts'
import { DEFAULT_VARIANT } from '@/domains/variants/types/models/VariantModel.types.ts'

export const useProductVariantStore = defineStore('productVariant', () => {
  const _productStore = useProductStore()

  const options = ref<StoreProductVariantOptions>({
    types: [],
    pricingTypes: [],
    vatRates: [],
    skuTypes: [],
    locations: [],
    fees: [],
    measurementUnits: [],
    measurementUnitTypes: [],
    availableSalesChannels: []
  })

  const variants = ref<StoreVariant>({
    atRunTime: {
      formSchema: [],
      xhrSchema: []
    },
    atRest: {
      formSchema: [],
      xhrSchema: []
    }
  })

  const getDefaultVariant = (): VariantModel => ({
    ...DEFAULT_VARIANT(),
    vat_rate_id: _productStore.defaults.vatRate.id,
    // ⚠ `|| null`, because `defaultMeasurementUnit` answers `{ id: 0 }` when it
    // cannot find the unit — an empty option list, say. `unit_id` reaches the
    // server as `VariantDTO::$unitId`, a plain `?int` that nothing validates,
    // and lands on `variants.pricing_unit_id`. That column is nullable, so null
    // saves; zero is not a row in `measurement_units` and fails the foreign key
    // with a 500 pointing at no field the merchant ever filled.
    unit_id: _productStore.defaults.measurementUnit.id || null
  })

  const defaults = computed(() => {
    return {
      variant: getDefaultVariant
    }
  })

  return {
    variants,
    options,
    defaults
  }
})
